import React, { MutableRefObject, useCallback, useEffect, useRef } from "react";
import {useAppDispatch, useAppSelector} from "../state/hooks";
//TODO 20241210 - get these from elsewhere.
/* import {
    addTable,
    Column,
    ColumnFieldsDictionary,
    Comp,
} from "../state/slices/diagramSlice";
 */
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGripLines, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import CompsFieldInput from "./CompsFieldInput";
//import OptionalSelect from "./optionalSelect";
//import { newProjectBuilder, ProjectBuilder } from "../state/objects/projectBuilder";
import { selectComp, selectCurrentProject, selectCurrentProjectName, selectProjects, swapCols, updateProject, upsertTable } from "../state/slices/systemSlice";
//import { createSelector } from "@reduxjs/toolkit";
import { Column, ColumnFieldsDictionary, Comp } from "../state/objects/comp";
import { useDrag, useDrop } from "react-dnd";
import { localconsole } from "../App";
import { getEmptyImage } from "react-dnd-html5-backend";

const DRAGDROPITEM = 'column';

interface ColProps {
    compKey: string,
    options?: string[],  //used to pass predefined values for columns, developed when I extended with gantt which I have now abandoned but leaving this for now
}

interface DraggableColProps {
    compId: string,
    colKey: number,
    //isActive: boolean,
    colId: string,
    //setActive: () => void,
    //setInactive: () => void,
    options?: string[],  //used to pass predefined values for columns, developed when I extended with gantt which I have now abandoned but leaving this for now
}

const DraggableColumn = (props: DraggableColProps) => {
    const dispatch = useAppDispatch()
    const component = useAppSelector(state => selectComp(props.compId)(state))
    const items = component?.columns ?? []
    const col = items[props.colKey]


    const updateColumn = (column: Column) => {
        if(component){
            let cols = component.columns.filter((c) => c.id !== column.id)
            let col_index = component.columns.findIndex((c) => c.id === column.id)
            cols.splice(col_index, 0, column)
            let t = {
                ...component,
                columns: cols
            }


            dispatch(upsertTable(t))
        }
    }

    const binCol = (item_id: string) => {
        // get the number from the data-key attribute on the row div
        //const elem = (e.currentTarget.parentElement)?e.currentTarget.parentElement.parentElement:null;
        //if ( elem != null ) {
            //let elemId = elem.getAttribute("data-key")
            //let id = (elemId && elemId!= null)?parseInt(elemId):0;

            //console.log(id)
            //console.log(active_component)
            if ( component ) {
                let cols: Column[] = component.columns.filter((i) => i.id !== item_id)
                const t: Comp = {
                    ...component,
                    "columns": cols
                };

                dispatch(upsertTable(t))

            }
        //}
    }

    //dnd functions
    //cancelling drag and drop
    const originalIndex = props.colKey
const findItem = useCallback(
        (id: string) => {
            //localconsole(`findItem: ${id}`)
        const keyItem = Object.entries(items).filter(([i, c]) => c.id == id)[0]
        const item = keyItem[1]
        return {
            item,
            index: item.id,
        }
        },
        [items],
    )

    const moveItem = useCallback(
        (id: string, overId: string, insertBefore: boolean) => {
            localconsole(`move ${id} ${insertBefore ? 'before' : 'after'} ${overId}`)
        
            dispatch(swapCols({compId: component?.id ?? "", from: id, to: overId, insertBefore: insertBefore}))
        
        },
        [items],
    )

    /*useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, []);*/
    
    const [{ isDragging }, drag] = useDrag(
        () => ({
        type: DRAGDROPITEM,
        item: { id: props.colId, itemKey: originalIndex }, //TODO change to Key to do slice insert in state swapCols
        canDrag: (monitor) => {
            return !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName ?? "")
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //lastTargetIndex.current = null
            const { id: droppedId, itemKey } = item
            const didDrop = monitor.didDrop()
            if (!didDrop) {
                //revert the item to original position
                localconsole(`revert ${droppedId} to ${itemKey}`)
                
                const fromIndex = items.findIndex(k => k.id === droppedId);
                const toIndex = itemKey;

                //direction
                const direction = fromIndex < toIndex ? false : true;

                moveItem(droppedId, items[itemKey].id , direction);
                
            }
        },
        }),
        [props.colId, originalIndex, moveItem, items],
    )
    
    const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)
    
    const [, drop] = useDrop(
            () => ({
            accept: DRAGDROPITEM,
            hover({ id }: { id: string }, monitor) {
                //localconsole(`Hovering over ${id}`)
    
                //don't move over itself
                if (id === props.colId) return;
    
                const overIndex = props.colId;
                const dragIndex = id;
    
                //don't move if already switched
                if (dragIndex === overIndex) return;
    
                //don't jump back and forth
                //if (lastTargetIndex.current === overIndex) return;
    
                //lastTargetIndex.current = overIndex;
    
                const hoverBoundingRect = ref.current?.getBoundingClientRect();
                if (!hoverBoundingRect) return
                const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                const clientOffset = monitor.getClientOffset();
                if (!clientOffset) return
                const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    
                if (hoverClientY > hoverMiddleY) {
                    // insert after
                    localconsole(`Below`)
                    moveItem(dragIndex, overIndex, false)
                } else {
                    // insert before
                    localconsole(`Above`)
                    moveItem(dragIndex, overIndex, true)
                }
                
                
            },
            }),
            [findItem, moveItem],
        )
        const setRef = useCallback((node: HTMLDivElement | null) => {
        if (node) {
            drag(drop(node))
            ref.current = node // store DOM for rect access
        }
        }, [drag, drop])


    return props.options && col.name && !props.options.includes(col.name) ? <tr></tr>  :
                <tr key={col.id} data-key={col.id} className={"has-text-centered"} 
                
                
                //stop drag propagating to parent comp
                //TODO - drag and drop configured I think but not working. Stop prop might be interfereing with livbrary, without it it gets handled by parent comp
                //onDragStart={(e) => e.stopPropagation()}
                >
                    <td ref={setRef}><span className={"icon"}>
                                <FontAwesomeIcon icon={faGripLines}/>
                            </span></td>
                    <td>
                        <div className={"field has-addons"}>
                            <div className={"control is-expanded"}>
                                {
                                    props.options ?
                                            <div className="select is-fullwidth is-small">
                                                <select id={"event_select_" + col.id}
                                                        onChange={(e) => updateColumn({
                                                            ...col,
                                                            name: e.currentTarget.value
                                                        })}
                                                        defaultValue={col.name}


                                                >
                                                    <option disabled selected>Select an option</option>
                                                    {props.options.map((o) =>
                                                        <option value={o}>{o}</option>
                                                    )}


                                                </select>


                                            </div> :
                                        <CompsFieldInput record={col} field={ColumnFieldsDictionary.name}
                                                         setRecord={(c) => updateColumn(c)}/>
                                }

                            </div>
                            
                        </div>
                    </td>
                    <td><CompsFieldInput record={col} field={ColumnFieldsDictionary.db_name}
                                         setRecord={(c) => updateColumn(c)}/>
                    </td>
                    <td>
                                            <div className={"control"}>
                                <button className={"button is-danger is-small"} onClick={() => binCol(col.id)}
                                        title={"Delete Field"}
                                >
                            <span className={"icon"}>
                                <FontAwesomeIcon icon={faTrash}/>
                            </span>
                                </button>
                            </div>
                    </td>
                </tr>

}


function Cols(props: ColProps) {
    
    const currentProject = useAppSelector(state => selectCurrentProject(state));
    const active_component = currentProject.components[props.compKey]

    const dispatch = useAppDispatch()

    const newItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        //let column_ids = active_component.columns.map( (c, i) => i )
        //console.log( active_component.columns )
        dispatch(upsertTable({
            ...active_component,
            columns: active_component.columns.concat([ { id: crypto.randomUUID() } ])
        }))
    }



    

    

    
    const [, drop] = useDrop(() => ({ accept: DRAGDROPITEM }))

    //if options are passed, only show columns in the available options, others are hidden. If there are no options, show all the fields for the component. This supports the Events for Gantt charts using columns to hold properties displayed as fields
    const itemList = active_component ? active_component.columns.map((col, i) =>
        <DraggableColumn compId={active_component.id} colKey={i} colId={col.id} options={props.options}/>
            
    ) : <tr></tr>


    return (
        <div className={(!active_component) ? "is-hidden" : ""}>

            <div className={""}>
                <table className={"table is-fullwidth has-text-centered "}>
                    <thead>
                    <tr>
                        <th></th>
                        <th className={"has-text-centered"}>Field</th>
                        <th className={"has-text-centered"}>{props.options ? "Value" : "Column"}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody ref={drop}>{itemList}</tbody>
                </table>

                <div className={"has-text-centered"}>
                    <button className={"button is-success is-inverted pulse is-small is-rounded p-3"} onClick={newItem}
                            onMouseOver={(e) => e.currentTarget.classList.remove("pulse")}
                            title={"Add Column"}
                    >
                    <span className={"icon"}>
                        <FontAwesomeIcon icon={faPlus}/>
                    </span>
                    </button>
                </div>
            </div>


        </div>
    );
}

export default Cols;